var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinanceWel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_145_1148)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0.456299,
    width: 51,
    height: 51,
    rx: 10,
    fill: "url(#pattern0)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_145_1148",
    x: 0,
    y: -0.543701,
    width: 59,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_145_1148"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_145_1148",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_145_1148"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.68 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_145_1148",
    result: "effect3_innerShadow_145_1148"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_145_1148",
    transform: "scale(0.0135135)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_145_1148",
    width: 74,
    height: 74,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABKCAYAAAAc0MJxAAAC10lEQVR4Ae3YbW7CMAwGYG7EBXaO3WYX4wd/d4FJ4xygSZMQdDLwspLVjlNS25pcKco+0jR5Zrthq8NmPWSrG6wSqY5ERgmlzKiESihdSmlLT0ZURlRGlMtxJlMvUy9TL1NP+6r2GJc1KmtU1qisUR61R/vMcDXq++NtoKbdgNW4UFAEhCsaVhioMVJErBBQU0jRsNyhJKRIWK5QGqQoWG5QLUgRsFyg5iB5Y5lDPYPkiWUKpUE6Hw8DtdpFc1kdNuk5ZlBapK/314FaNCwTqBYkREk0rMWh5iBFxHKHohSj6AFO2Wsiy6JeLQ5FG+eiqoYENAnLAonWYQI1hcUibV+GA7XiX7RTWFZIi0DR4rlUQmRJSKf950CthsUh0bO535X4Ld93jahfiL2INQm5fbkA4fwkYXEQ16jbX6bgxrTgjMd2gwISNno+8ljjBVy+LpAwB4f15/7N+nb2uiLh/p5YXaBKJCxUhcUgYQ4N1jiScB/6XlhPQ3FIWKiIVUHCHBKWhIT7e2AZQAnnpAvUDvth+9N+N1ncKQWvUPJnwxBQtFguqti32/jVX8GSkFCrJKweSPScpyMKiy2xVEgAY7A0SHj+FFYvpK5QNBmwJCQaQ5vCBu99gcUh0b0cwBiLG3N/Hv5Iyr5bRGEBLMQDJHN0uGFJSPRyoIuDkCCxxjl9dyhuEbSx8cW+DcWPMMudk7h14+cmUCUSwFisIh2uKfWIhDm4yMIGe/WLQ3FI2GgNS0LCHBZY7lC0WQ5Lg0T3/wsoCv1aVE1hRUKiPSweUagRLVjRkEyhWiKLUrF2WaQb/sjmUFqsaEguUM9iWUcSrdcNai6WF5IrVCuWJ5I7lBbLGykEVA0rAlIYKA4rClIoqBIrElI4KGBFQwoJRYuK2Mw+60XcfMuaEkoZwQmVUH1rXUZURlRGlMvxIVMvUy9TL1Ov5aRsPTZrVNaorFFZo6zrTsvzfgC2DYHsohySbQAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceWel);
export default __webpack_public_path__ + "static/media/binance_wel.6346f69a9c1303e1a730bc8f7d37b7d7.svg";
export { ForwardRef as ReactComponent };